import { useLocationStore } from '@global-store/stores/location'

export const formatPrice = (
  number: number,
  currency: string,
  numberFormatOptions?: Intl.NumberFormatOptions
) => {
  const locationStore = useLocationStore()

  return new Intl.NumberFormat(locationStore.currentLocale, {
    style: 'currency',
    currency,
    ...numberFormatOptions,
  }).format(number / 100)
}
